<div class="page-wrapper">
    <app-preloader></app-preloader>
    <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>